export default {
  VALID: 1, // 可用
  DISABLE: 2, // 门槛不符合
  CHNOTMATCH: 4, // 渠道不符合
  FROZEN: 8, // 冻结状态
  EXPIRED: 16, // 过期状态

  // 游戏业务券状态
  // 券状态 1-未使用 2-已冻结 3-已使用
  GAMECOUPON_VALID: 1,
  GAMECOUPON_FROZEN: 2,
  GAMECOUPON_USED: 3
}
